import {Component, OnInit} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../environments/environment";
import {AuthService} from "../../../services/auth/auth-service";
import {LanguageControllerService} from "../../../services/language-controller/language-controller.service";
import {Store} from "../../../services/store.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  providers: [AuthService],
})
export class LoginComponent implements OnInit {

  public error: string;
  public OAuthRedirectUrl: string = environment.OAUTH_REDIRECT_URL;
  public authUrl: string = environment.CAS_URL;
  public OAuthClientId: string = environment.OAUTH_CLIENT_ID;
  public keycloakActive: boolean = Boolean(environment.KEYCLOAK_ACTIVE);
  public randomHash: string = this.authService.randomId();
  public loginLink: string;

  constructor(private http: HttpClient,
              private languageService: LanguageControllerService,
              private authService: AuthService,
              public translate: TranslateService, public store: Store) {
    translate.setDefaultLang(store.state.common.lang);
    languageService.getLanguages().subscribe(
      (data) => {
        translate.addLangs(data.map((l) => l.code));
      });
  }

  public async ngOnInit() {
    this.error = this.authService.getSearchParameters().error;
    this.randomHash = this.authService.randomId();
    if (this.keycloakActive) {
      try {
        if (await this.authService.isLoggedIn()) {
          if (this.authService.isUserInRole()) {
            window.location.href = "/services";
            return;
          }
          return await this.authService.logout(window.location.origin + "/login?error=bpa.no.rights");
        }
      } catch (e) {
        window.location.href = "/login";
        return;
      }
    } else {
      this.loginLink = this.authUrl + "cas/spa.html#/?response_type=code&client_id=" + this.OAuthClientId + "&state=" + this.randomHash + "&scope=any&redirect_uri=" + this.OAuthRedirectUrl + "&lang=" + this.translate.currentLang;
      if (!await this.authService.isLoggedIn()) {
        window.location.href = this.loginLink;
        return;
      }
      return await this.authService.logout(window.location.origin + "/login");
    }
  }

  public login() {
    return this.authService.login({
      loginLink: this.loginLink,
      locale: this.translate.currentLang,
    });
  }
}
